import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=7e049fa0&scoped=true&"
import script from "./js/banner-item.js?vue&type=script&lang=js&"
export * from "./js/banner-item.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e049fa0",
  null
  
)

export default component.exports